import { render, staticRenderFns } from "./hesapkodu.vue?vue&type=template&id=985fc04a&scoped=true&"
import script from "./hesapkodu.vue?vue&type=script&lang=js&"
export * from "./hesapkodu.vue?vue&type=script&lang=js&"
import style0 from "./hesapkodu.vue?vue&type=style&index=0&id=985fc04a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "985fc04a",
  null
  
)

export default component.exports